<!-- them ten chi nhanh -->
<form #f="ngForm" (ngSubmit)="!f.form.valid? accordion.openAll() : 'true' && f.form.valid && onUpdateBranch()"
  appFocusFirstElement
  [appCheckInputNumber]="['taxCode','accountNumber','certificateNo', 'representativeCertificateNo']"
  [appCheckPhone]="['phone', 'fax']">
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{'title.update_branch' | translate}} {{oldBranchName}}
        <small class="form-text text-gray pull-left pb-2 float-right">(<span style="color: red;">*</span>) {{'form.info' | translate}}</small>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <!-- Thông tin doanh nghiệp -->
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.enterprise_info' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row">
            <!-- Tên đăng nhập -->
            <div class="col-md-4">
              <small>{{'form.username' | translate}}</small>
              <p class="dotted">{{branch.adminUser}}</p>
            </div>

            <!-- Tên chi nhánh -->
            <div class="col-md-4">
              <mat-form-field class="mat-full-width">
                <input (focusout)="branch.name = branch.name.trim()" #focusInput matInput autocomplete="off" type="text"
                  [placeholder]="'form.branch_name' | translate" name="name" [(ngModel)]="branch.name" #name="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && name.invalid }" required
                  [maxlength]="branchNameMaxlength" />
                <button mat-button *ngIf="branch.name" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="branch.name=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || name.invalid">
                  <span class="text-error" *ngIf="name?.errors?.required">
                    {{'validation.branch_name' | translate}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Loại giấy tờ -->
            <div class="col-md-4">
              <mat-form-field class="mat-full-width">
                <mat-label>{{'form.type' | translate}}</mat-label>
                <mat-select #certificationTypeSelect (focusout)="(checkFocus = true)"
                  (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, certificationTypeSelect)" id="certificateId"
                  name="certificateId" [(ngModel)]="branch.certificateId">
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate" [formControl]="certificateTypeFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let certificate of filteredCertificateType | async" [value]="certificate.id"
                    (click)="this.commonService.closeDropdownList(this.certificationTypeSelect)">
                    {{getEnterpriseTypeOptions(certificate.langs)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Số giấy tờ -->
            <div class="col-md-4">
              <mat-form-field class="mat-full-width">
                <input #certificateNoEl (focusout)="branch.certificateNo = branch.certificateNo.trim()" matInput
                  autocomplete="off" type="text" [placeholder]="'form.gpkd' | translate" name="certificateNo"
                  [(ngModel)]="branch.certificateNo" #certificateNo="ngModel" maxlength="20" required/>
                <button mat-button *ngIf="branch.certificateNo" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="branch.certificateNo=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || certificateNo.invalid">
                  <span *ngIf="certificateNo?.errors?.required" class="text-error">
                    {{'validation.gpkd_required' | translate}}
                  </span>
                  <span *ngIf="certificateNo?.errors?.validInput" class="text-error">
                    {{'validation.gpkd_format' | translate}}
                  </span>
                  <span *ngIf="certificateNo?.errors?.duplicate" class="text-error">
                    {{'validation.gpkd_duplicate' | translate}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Ngày cấp -->
            <div class="col-md-4">
              <mat-form-field class="mat-full-width">
                <input matInput [placeholder]="'form.issued_date' | translate" autocomplete="off"
                  [matDatepicker]="issuedDate1" [max]="maxDate"
                  (change)="this.commonService.resetDatePicker(pickerInput.value, this.ngForm.controls['issuedDate'])"
                  name="issuedDate" #issuedDate="ngModel" [(ngModel)]="branch.issuedDate" maxlength="10" #pickerInput />
                <mat-datepicker-toggle matSuffix [for]="issuedDate1">
                  <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true" [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                </mat-datepicker-toggle>
                <mat-datepicker #issuedDate1></mat-datepicker>
                <mat-error *ngIf="f.submitted || issuedDate.invalid">
                  <span class="text-error">
                    {{getErrorDateMessage(pickerInput.value)}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Nơi cấp -->
            <div class="col-md-4">
              <mat-form-field class="mat-full-width">
                <input (focusout)="branch.issuedAt = branch.issuedAt.trim()" matInput
                  [placeholder]="'form.issued_by' | translate" autocomplete="off" type="text" name="issuedAt"
                  [(ngModel)]="branch.issuedAt" maxlength="200" />
                <button mat-button *ngIf="branch.issuedAt" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="branch.issuedAt=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Mã số thuế -->
            <div class="col-md-4">
              <small>{{'form.tax_code' | translate}}</small>
              <p class="dotted">{{branch.taxCode}}</p>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Thông tin người đại diện -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.representative_info' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row">
            <!-- Tên người đại diện -->
            <div class="col-md-4">
              <mat-form-field class="mat-full-width">
                <input (focusout)="branch.representative = branch.representative.trim()" matInput autocomplete="off"
                  type="text" [placeholder]="'form.fullname' | translate" name="representative"
                  [(ngModel)]="branch.representative" #representative="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && representative.invalid }" required maxlength="200" />
                <button mat-button *ngIf="branch.representative" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="branch.representative=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || representative.invalid">
                  <span class="text-error" *ngIf="representative?.errors?.required">
                    {{'validation.representative' | translate}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Chức vụ -->
            <div class="col-md-4">
              <mat-form-field class="mat-full-width">
                <input (focusout)="branch.position = branch.position.trim()" matInput autocomplete="off" type="text"
                  [placeholder]="'form.position' | translate" name="position" [(ngModel)]="branch.position"
                  #position="ngModel" [ngClass]="{ 'is-invalid': f.submitted && position.invalid }" required
                  maxlength="200" />
                <button mat-button *ngIf="branch.position" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="branch.position=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || position.invalid">
                  <span class="text-error" *ngIf="position?.errors?.required">
                    {{'validation.position' | translate}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Giới tính -->
            <!-- <div class="col-md-4">
              <mat-form-field class="mat-full-width">
                <mat-label>{{'form.sex' | translate}}</mat-label>
                <mat-select #sexSelect1 (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false" (focus)="commonService.openComboBox(checkFocus, sexSelect1)" id="sex"
                name="sex" [(ngModel)]="branch.sex">
                  <mat-option [value]="true" (click)="this.commonService.closeDropdownList(this.sexSelect1)">{{'form.male' | translate}}</mat-option>
                  <mat-option [value]="false" (click)="this.commonService.closeDropdownList(this.sexSelect1)">{{'form.female' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div> -->
            <div class="col-md-4">
              <mat-label style="color: #858796">{{'form.sex' | translate}}</mat-label><br>
              <mat-radio-group #sexSelect1 id="sex" name="sex" [(ngModel)]="branch.sex">
                <mat-radio-button [value]="true" class="pt-2 mr-3">{{'form.male' | translate}}</mat-radio-button>
                <mat-radio-button [value]="false">{{'form.female' | translate}}</mat-radio-button>
              </mat-radio-group>
            </div>

            <!-- Ngày sinh -->
            <div class="col-md-4">
              <mat-form-field class="mat-full-width">
                <input matInput autocomplete="off" [placeholder]="'form.birthday' | translate" [max]="maxDate"
                  [matDatepicker]="birthday1"
                  (change)="this.commonService.resetDatePicker(pickerInput2.value, this.ngForm.controls['birthday'])"
                  name="birthday" [(ngModel)]="branch.birthday" #birthday=ngModel maxlength="10" #pickerInput2 />
                <mat-datepicker-toggle matSuffix [for]="birthday1">
                  <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true" [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                </mat-datepicker-toggle>
                <mat-datepicker #birthday1></mat-datepicker>
                <mat-error *ngIf="f.submitted || birthday.invalid">
                  <span class="text-error">
                    {{getErrorDateMessage(pickerInput2.value)}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Loại giấy tờ -->
            <div class="col-md-4">
              <mat-form-field class="mat-full-width">
                <mat-label>{{'form.type' | translate}}</mat-label>
                <mat-select #representativeCertificateSelect (focusout)="(checkFocus = true)"
                  (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, representativeCertificateSelect)"
                  id="representativeCertificateId" name="representativeCertificateId"
                  [(ngModel)]="branch.representativeCertificateId">
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate"
                      [formControl]="representativeCertificateTypeFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let representative of filteredRepresentativeCertificateType | async "
                    [value]="representative.id"
                    (click)="this.commonService.closeDropdownList(this.representativeCertificateSelect)">
                    {{getEnterpriseTypeOptions(representative.langs)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Số giấy tờ-->
            <div class="col-md-4">
              <mat-form-field class="mat-full-width">
                <input (focusout)="branch.representativeCertificateNo = branch.representativeCertificateNo.trim()"
                  matInput autocomplete="off" type="text" [placeholder]="'form.certification_no' | translate"
                  name="representativeCertificateNo" [(ngModel)]="branch.representativeCertificateNo"
                  #representativeCertificateNo="ngModel" maxlength="20" appCheckSpace />
                <button mat-button *ngIf="branch.representativeCertificateNo" matSuffix mat-icon-button
                  aria-label="Clear" (click)="branch.representativeCertificateNo=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || representativeCertificateNo.invalid">
                  <span *ngIf="representativeCertificateNo?.errors?.validInput" class="text-error">
                    {{'validation.gpkd_format' | translate}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Ngày cấp -->
            <div class="col-md-4">
              <mat-form-field class="mat-full-width">
                <input autocomplete="off" matInput [placeholder]="'form.issued_date' | translate"
                  [matDatepicker]="representativeIssuedDate1" [max]="maxDate"
                  (change)="this.commonService.resetDatePicker(pickerInput3.value, this.ngForm.controls['representativeIssuedDate'])"
                  name="representativeIssuedDate" [(ngModel)]="branch.representativeIssuedDate" maxlength="10"
                  #representativeIssuedDate2=ngModel #pickerInput3 />
                <mat-datepicker-toggle matSuffix [for]="representativeIssuedDate1">
                  <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true" [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                </mat-datepicker-toggle>
                <mat-datepicker #representativeIssuedDate1></mat-datepicker>
                <mat-error *ngIf="f.submitted || representativeIssuedDate2.invalid">
                  <span class="text-error">
                    {{getErrorDateMessage(pickerInput3.value)}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Nơi cấp -->
            <div class="col-md-8">
              <mat-form-field class="mat-full-width">
                <input (focusout)="branch.representativeIssuedOn = branch.representativeIssuedOn.trim()" matInput
                  autocomplete="off" type="text" [placeholder]="'form.issued_by' | translate"
                  name="representativeIssuedOn" [(ngModel)]="branch.representativeIssuedOn" maxlength="200" />
                <button mat-button *ngIf="branch.representativeIssuedOn" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="branch.representativeIssuedOn=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Thông tin liên hệ -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.address' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row">
            <!-- Số điện thoại -->
            <div class="col-sm-4">
              <mat-form-field class="mat-full-width">
                <input (focusout)="branch.phone = branch.phone.trim()" autocomplete="off" type="text" matInput
                  [placeholder]="'form.phone' | translate" name="phone" [(ngModel)]="branch.phone" #phone="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && phone.invalid }" required [maxlength]="maxLengthPhone" />
                <button mat-button *ngIf="branch.phone" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="branch.phone=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || phone.invalid">
                  <span class="text-error" *ngIf="phone?.errors?.required">
                    {{'validation.phone' | translate}}
                  </span>
                  <span *ngIf="phone?.errors?.validInput" class="text-error">{{'validation.phone_format' | translate}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Email -->
            <div class="col-sm-4">
              <mat-form-field class="mat-full-width">
                <mat-label>{{'form.email' | translate}}</mat-label>
                <input (focusout)="branch.email = branch.email.trim()" autocomplete="off" matInput
                  [placeholder]="'placeholder.email' | translate" type="text" name="email" [(ngModel)]="branch.email"
                  #email="ngModel" required [pattern]="emailPattern" [maxlength]="emailMaxlength" />
                <button mat-button *ngIf="branch.email" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="branch.email=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || email.invalid">
                  <span class="text-error" *ngIf="email?.errors?.required">
                    {{'validation.email' | translate}}
                  </span>
                  <span class="text-error" *ngIf="email?.errors?.pattern">
                    {{'validation.email_format' | translate}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Fax -->
            <div class="col-sm-4">
              <mat-form-field class="mat-full-width">
                <input (focusout)="branch.fax = branch.fax.trim()" autocomplete="off" matInput
                  [placeholder]="'form.fax' | translate" type="text" name="fax" [(ngModel)]="branch.fax" #fax="ngModel"
                  maxlength="20" />
                <button mat-button *ngIf="branch.fax" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="branch.fax=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || fax.invalid">
                  <span *ngIf="fax.invalid" class="text-error">{{'validation.fax_format' | translate}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Tỉnh/Thành phố-->
            <div class="col-md-4">
              <mat-form-field class="mat-full-width">
                <mat-label>{{'form.city' | translate}}</mat-label>
                <mat-select #citySelect (focusout)="(checkFocus = true)"
                  (focus)="commonService.openComboBox(checkFocus, citySelect)" id="cityId" name="cityId"
                  (selectionChange)=" checkFocus = false; onChange($event.value);"
                  [(ngModel)]="branch.addresses[0].cityId" #cityId="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && cityId.invalid }" required maxlength="100">
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate" [formControl]="cityFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option [value]="null" selected>{{'form.select_address' | translate}}</mat-option>
                  <mat-option *ngFor="let city of filteredCity | async" [value]="city.id"
                    (click)="this.commonService.closeDropdownList(this.citySelect)">
                    {{ city.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="f.submitted || cityId.invalid">
                  <span class="text-error" *ngIf="cityId?.errors?.required">
                    {{'validation.city' | translate}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Quận/Huyện -->
            <div class="col-sm-4">
              <mat-form-field class="mat-full-width">
                <mat-label>{{'form.district' | translate}}</mat-label>
                <mat-select #districtSelect (focusout)="(checkFocus = true)"
                  (focus)="commonService.openComboBox(checkFocus, districtSelect)" id="districtId" name="districtId"
                  (selectionChange)="checkFocus = false; onChange($event.value, 2);"
                  [(ngModel)]="branch.addresses[0].districtId" #districtId="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && districtId.invalid }" required maxlength="100">
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate" [formControl]="districtsFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option [value]="null" selected>{{'form.select_address' | translate}}</mat-option>
                  <mat-option *ngFor="let district of filteredDistricts | async" [value]="district.id"
                    (click)="this.commonService.closeDropdownList(this.districtSelect)">
                    {{ district.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="f.submitted || districtId.invalid">
                  <span class="text-error" *ngIf="districtId?.errors?.required">
                    {{'validation.district' | translate}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Phường/Xã -->
            <div class="col-sm-4">
              <ng-container *ngIf="notHasWard; else hasWard">
                <mat-form-field class="mat-full-width">
                  <mat-label>{{'form.ward' | translate}}</mat-label>
                  <mat-select #wardIdSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, wardIdSelect)" id="wardId" name="wardId"
                    [(ngModel)]="branch.addresses[0].wardId" #wardId="ngModel">
                    <mat-option>
                      <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                        [placeholderLabel]="'search_form.search' | translate" [formControl]="wardFilterCtrl">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option [value]="null" selected>{{'form.select_address' | translate}}</mat-option>
                    <mat-option *ngFor="let ward of filteredWard | async" [value]="ward.id">
                      {{ ward.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
              <ng-template #hasWard>
                <mat-form-field class="mat-full-width">
                  <mat-label>{{'form.ward' | translate}}</mat-label>
                  <mat-select #wardSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, wardSelect)" id="wardId" name="wardId"
                    [(ngModel)]="branch.addresses[0].wardId" #wardId="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && wardId.invalid }" required>
                    <mat-option>
                      <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                        [placeholderLabel]="'search_form.search' | translate" [formControl]="wardFilterCtrl">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option [value]="null" selected>{{'form.select_address' | translate}}</mat-option>
                    <mat-option *ngFor="let ward of filteredWard | async" [value]="ward.id"
                      (click)="this.commonService.closeDropdownList(this.wardSelect)">
                      {{ ward.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="f.submitted || wardId.invalid">
                    <span class="text-error" *ngIf="wardId?.errors?.required">
                      {{'validation.ward' | translate}}
                    </span>
                  </mat-error>
                </mat-form-field>
              </ng-template>
            </div>

            <!-- Địa chỉ -->
            <div class="col-sm-8">
              <mat-form-field class="mat-full-width">
                <input (focusout)="branch.addresses[0].address = branch.addresses[0].address.trim()" autocomplete="off"
                  matInput [placeholder]="'form.address' | translate" type="text" name="address"
                  [(ngModel)]="branch.addresses[0].address" #address="ngModel"
                  [ngClass]="{ 'is-invalid': f.submitted && address.invalid }" required maxlength="200" />
                <button mat-button *ngIf="branch.addresses[0].address" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="branch.addresses[0].address=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || address.invalid">
                  <span class="text-error" *ngIf="address?.errors?.required">
                    {{'validation.address' | translate}}
                  </span>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Thông tin thanh toán -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.pay_info' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row">
            <!-- Số tài khoản -->
            <div class="col-md-4">
              <mat-form-field class="mat-full-width">
                <input (focusout)="branch.accountNumber = branch.accountNumber.trim()" matInput autocomplete="off"
                  [maxlength]="accountNumberMaxlength" type="text" [placeholder]="'form.accnumber' | translate"
                  name="accountNumber" [(ngModel)]="branch.accountNumber" #accountNumber="ngModel" />
                <button mat-button *ngIf="branch.accountNumber" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="branch.accountNumber=''">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="f.submitted || accountNumber?.invalid || accountNumber?.errors?.validIp">
                  {{'validation.account_number' | translate}}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Ngân hàng -->
            <div class="col-md-4">
              <mat-form-field class="mat-full-width">
                <input (focusout)="branch.bankName = branch.bankName.trim()" matInput autocomplete="off" type="text"
                  [placeholder]="'form.bank' | translate" name="bankName" [(ngModel)]="branch.bankName"
                  [maxlength]="bankMaxlength" />
                <button mat-button *ngIf="branch.bankName" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="branch.bankName=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Chi nhánh -->
            <div class="col-md-4">
              <mat-form-field class="mat-full-width">
                <input (focusout)="branch.bankBranch = branch.bankBranch.trim()" matInput autocomplete="off" type="text"
                  [placeholder]="'form.branch' | translate" name="bankBranch" [(ngModel)]="branch.bankBranch"
                  [maxlength]="bankMaxlength" />
                <button mat-button *ngIf="branch.bankBranch" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="branch.bankBranch=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Tệp đính kèm -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'title.attach' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="pb-3">
            <app-upload-multi-file (hasChange)="onAttachmentChange($event)" [arrAttachments]="this.branch.attachments">
            </app-upload-multi-file>
            <div class="text-center">
              <mat-hint class="hint-text">
                {{'hint.attach_accept_pdf_image' | translate}}<br>
                {{'hint.attach_accept_pdf_image_sub' | translate}}
              </mat-hint>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>

    <!-- Huỷ bỏ & Lưu  -->
    <mat-card-actions class="text-center">
      <button mat-stroked-button color="primary" type="button" (click)="onNoClick()">
        <mat-icon class="mr-0">cancel</mat-icon>{{ 'button.cancel' | translate }}
      </button>
      <button mat-raised-button [disabled]="!isFormChanging" color="primary" type="submit">
        <mat-icon class="mr-0">save</mat-icon>{{ 'button.save' | translate }}
      </button>
    </mat-card-actions>
  </mat-card>
</form>
